import { get, post, put, del } from 'services/api-client';

const couponService = {
  get: (id) => get(`/coupon/${id}`),

  getByCode: (code) => get(`/coupon/code?code=${code}`),

  create: (data) => post(`/coupon/create`, data),

  update: (data) => put(`/coupon/update`, data),

  delete: (id) => del(`/coupon/${id}`),

  disableOrEnable: (id) => put(`/coupon/${id}/toggle`),
}

export default couponService;